import { apiClient } from "./authService";
import type { BusinessTypeKey } from "../platform/config";

/** Owner only: switches the organization's business type. */
export const saveBusinessType = async (businessType: BusinessTypeKey): Promise<BusinessTypeKey> => {
  const { data } = await apiClient.put<{ businessType: BusinessTypeKey }>("/organization/business-type", {
    businessType,
  });
  return data.businessType;
};
